import { customization, template, view } from '@yola/ws-sdk';
import store from 'src/js/store';
import appendCustomSchemeToPaletteElement from './append-custom-scheme-to-palette-element';
import compileCustomTemplate from './compile-custom-template';
import buildPaletteTemplateVariables from './build-palette-template-variables';
import getSelectorByGlobalId from './get-selector-by-global-id';
import constants from '../constants';

const { GLOBAL_HEADER_CODE } = constants;

const preparePaletteElement = ({
  compiledPalette,
  parentNode = null,
  shouldMutateElement = false,
}) => {
  const state = store.getState();
  const paletteTemplate = customization.selectors.getColorPaletteTemplate(state);
  const selector = getSelectorByGlobalId(
    template.selectors.getVariableValueByPath(
      state,
      customization.constants.COLOR_PALETTE_VARIABLE
    ),
    GLOBAL_HEADER_CODE
  );

  const parentElement = parentNode || view.accessors.getLiveDocument();
  const element = parentElement.querySelector(selector);

  if (!element) {
    return { compiledElement: null, element: null };
  }

  const compiledPaletteStyle = compileCustomTemplate(paletteTemplate, {
    variables: buildPaletteTemplateVariables(compiledPalette.variables),
  });

  const compiledElement = shouldMutateElement ? element : element.cloneNode(false);
  compiledElement.innerHTML = compiledPaletteStyle;
  compiledElement.setAttribute(
    customization.constants.COLOR_PALETTE_DATA_ATTRIBUTE,
    compiledPalette.id
  );

  if (compiledPalette.variables.schemes) {
    Object.entries(compiledPalette.variables.schemes)
      .filter(([schemeId]) =>
        schemeId.startsWith(customization.constants.CUSTOM_COLOR_SCHEME_PREFIX)
      )
      .forEach(([schemeId, variables]) => {
        appendCustomSchemeToPaletteElement({
          schemeId,
          variables,
          element: compiledElement,
        });
      });
  }

  return { compiledElement, element };
};

export const mutatePaletteElement = ({ compiledPalette, parentNode }) => {
  preparePaletteElement({ compiledPalette, parentNode, shouldMutateElement: true });
  return parentNode;
};

export default preparePaletteElement;
